import {Loading} from "element-ui";

function Loader(){
    this.loading = null;
    this.loadDom;
    this.count = 0;
}
Loader.prototype.run = function(){
    this.count +=1;
    if(!this.loadDom){
        this.loadDom = document.createElement('div');
        this.loadDom.setAttribute("style","display: fixed;position: fixed;left: 0;top: 0;width: 100vw;height: 100vh;background: rgba(0,0,0,0.5);z-index: 9006;")
        this.loadDom.innerHTML = `
        <div id="root" style="height:90vh;margin:0;padding:0;overflow: hidden;display:flex;align-items: center;justify-content: center;">
            <div style="text-align: center;">
                <span style="-webkit-animation-delay: 0s;animation-delay: 0s;"></span>
                <span style="-webkit-animation-delay: .1s;animation-delay: .1s;"></span>
                <span style="-webkit-animation-delay: .15s;animation-delay: .15s;"></span>
                <span style="-webkit-animation-delay: .2s;animation-delay: .2s;"></span>
            </div>
        </div>`;
        document.body.appendChild(this.loadDom);
    }else{
        this.loadDom.style.display = "block";
    };
};
Loader.prototype.close = function(){
    if(this.count > 0){
        this.count -=1;
    };
    // if(this.count ===0 && this.loading){
    //     this.loading.close();
    //     this.loading = null;
    // };
    if(this.count ===0 && this.loadDom){
        this.loadDom.style.display = "none";
    };
};

export default new Loader();